import React, { useState } from 'react';
import { Card, Tabs } from 'antd';
import { CreditCardOutlined, ShoppingOutlined } from '@ant-design/icons';
import DispatchTable from '../../components/cards/DispatchTable';
import useGetCards from '../../hooks/cards/useGetCards';
import useGetProductOrders from '../../hooks/cards/useGetProductOrders';

const Dispatch = () => {
  const [activeTab, setActiveTab] = useState('single');

  // All cards data (WITH include_batch_cards for batch mode)
  const {
    data: allCardsData,
  } = useGetCards({
    include_batch_cards: true,
  });

  // Batch orders data
  const {
    data: productOrdersData,
    fetchNextPage: fetchNextPageProductOrders,
    hasNextPage: hasNextPageProductOrders,
    isFetchingNextPage: isFetchingNextPageProductOrders,
    isPending: isPendingProductOrders,
    isFetching: isFetchingProductOrders,
  } = useGetProductOrders({ status: 'pending-collection', sort_by: 'delivery-date' });

  const items = [
    {
      key: 'single',
      label: (
        <span>
          <CreditCardOutlined />
          Single Cards
        </span>
      ),
      children: (
        <DispatchTable
          mode="single"
          cardData={[]} // No pending dispatch data to display here
          fetchNextPage={() => {}} // No fetchNextPage for single cards
          hasNextPage={false} // No next page for single cards
          isFetchingNextPage={false} // No fetching for single cards
          isTableLoading={false} // No loading for single cards
        />
      ),
    },
    {
      key: 'batch',
      label: (
        <span>
          <ShoppingOutlined />
          Batch Orders
        </span>
      ),
      children: (
        <DispatchTable
          mode="batch"
          batchData={productOrdersData || []}
          fetchNextPageBatch={fetchNextPageProductOrders}
          hasNextPageBatch={hasNextPageProductOrders}
          isFetchingNextPageBatch={isFetchingNextPageProductOrders}
          isTableLoading={isFetchingProductOrders}
          allCards={allCardsData || []}
        />
      ),
    },
  ];

  return (
    <div className="layout-content">
      <Card bordered={false}>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={items}
          size="large"
          type="card"
        />
      </Card>
    </div>
  );
};

export default Dispatch; 